import { gql } from "@apollo/client"

const sharedFields = `
    id
    name
    customFieldType
    required
    readOnly
    attributeDefinition
`

export const BOOLEAN_CUSTOM_FIELD_FRAGMENT = gql`
  fragment BooleanCustomFieldFields on BooleanCustomField {
    ${sharedFields}
    defaultValueBoolean: defaultValue
  }
`

export const DATE_CUSTOM_FIELD_FRAGMENT = gql`
  fragment DateCustomFieldFields on DateCustomField {
    ${sharedFields}
    defaultValueDate: defaultValue
  }
`

export const NUMBER_CUSTOM_FIELD_FRAGMENT = gql`
  fragment NumberCustomFieldFields on NumberCustomField {
    ${sharedFields}
    defaultValueNumber: defaultValue
  }
`

export const STRING_CUSTOM_FIELD_FRAGMENT = gql`
  fragment StringCustomFieldFields on StringCustomField {
    ${sharedFields}
    defaultValueString: defaultValue
  }
`
